import { styled } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

export const GridContainer = styled(Grid)(({ theme }) => ({
  '& > .MuiGrid-item': {
    padding: theme.spacing(0, 1)
  }
}));
